export default {
  root: '/',
  preRegister: '/registration',
  register: '/registration/form',
  postRegister: '/registration/complete',
  resetPassword: '/registration/create-password',
  forgotPassword: '/registration/forgot-password',
  login: '/login',

  notifications: '/notifications',
  menu: '/menu',

  lobby: '/lobby',

  networking: '/networking-lounge',
  cloudflix: '/highlights',

  auditorium1: '/auditorium-hall/1',
  auditorium2: '/auditorium-hall/2',
  auditorium3: '/auditorium-hall/3',
  auditorium4: '/auditorium-hall/4',
  auditorium5: '/auditorium-hall/5',

  exhibition1: '/exhibition-hall/1',
  exhibition2: '/exhibition-hall/2',

  onDemand: '/on-demand',
}
